import { render, staticRenderFns } from "./classify-add.vue?vue&type=template&id=0e9e9abd&scoped=true&"
import script from "./classify-add.vue?vue&type=script&lang=js&"
export * from "./classify-add.vue?vue&type=script&lang=js&"
import style0 from "./classify-add.vue?vue&type=style&index=0&id=0e9e9abd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9e9abd",
  null
  
)

export default component.exports